import { getSongCollectionSongStats, GetSongCollectionSongStatsParams, usePaginatedFetch } from '@round/api';
import { useMemo } from 'react';
import useAbortableEffect from '../../../../../Hooks/useAbortableEffect';

export default function useCollectionSongs(
    collectionId: number | undefined | null,
    params: GetSongCollectionSongStatsParams
) {
    const fetchFunction = useMemo(
        () => (params: GetSongCollectionSongStatsParams, requestInit?: RequestInit) => {
            if (typeof collectionId !== 'number') {
                throw new Error('Collection must be selected');
            }

            return getSongCollectionSongStats(collectionId, params, requestInit);
        },
        [collectionId]
    );

    const utils = usePaginatedFetch(fetchFunction, params);

    useAbortableEffect(
        (signal) => {
            utils.getCurrentPage({ signal }).catch(() => {});
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [utils.getCurrentPage]
    );

    return utils;
}
